import React from 'react';

const About: React.FC = () => {
  return (
    <div className="pt-40 pb-32 animate-fade-in bg-white dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-6">
        {/* Hero Section */}
        <div className="text-center max-w-4xl mx-auto mb-32">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/5 dark:bg-white/5 text-primary dark:text-accent-400 text-[10px] font-black uppercase tracking-[0.3em] mb-10 border border-primary/10">
            Our Brand Heritage
          </div>
          <h1 className="text-7xl lg:text-[110px] font-display font-extrabold text-slate-900 dark:text-white mb-10 animate-slide-up leading-[0.9] tracking-tighter">
            Excellence in <br />
            <span className="text-primary italic">Compliance.</span>
          </h1>
          <p className="text-2xl text-slate-600 dark:text-slate-400 animate-slide-up stagger-1 leading-relaxed font-medium">
            We are a collective of chartered accountants, corporate lawyers, and tech visionaries <br className="hidden lg:block" />
            dedicated to architectural-grade compliance for modern Nigerian ventures.
          </p>
        </div>

        {/* Mission Centered - High impact typography */}
        <div className="relative mb-48">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-4xl bg-primary/5 rounded-full blur-[140px] -z-10 animate-pulse"></div>
          
          <div className="max-w-4xl mx-auto text-center py-20 px-8 lg:px-12 bg-slate-50/50 dark:bg-slate-900/30 rounded-[80px] border border-slate-100 dark:border-slate-800 shadow-premium">
            <h2 className="text-sm font-black text-primary uppercase tracking-[0.5em] mb-12">The Mission Statement</h2>
            <div className="space-y-10">
              <p className="text-4xl lg:text-5xl font-display font-bold text-slate-900 dark:text-white leading-[1.2]">
                "Bridging the gap between <br /> 
                <span className="text-primary">startup agility</span> and <br className="lg:hidden" /> 
                regulatory rigor."
              </p>
              <p className="text-xl lg:text-2xl text-slate-600 dark:text-slate-400 leading-relaxed font-medium">
                FinTrack was founded on the realization that founders in Nigeria spend over 40% of their critical first year fighting paperwork. We built the engine to automate that burden, allowing you to focus on the empire, not the audit.
              </p>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-12 mt-20 max-w-2xl mx-auto">
              <div className="p-12 bg-white dark:bg-slate-900 rounded-[48px] border border-slate-100 dark:border-slate-800 shadow-lg group hover:-translate-y-2 transition-transform duration-500">
                <p className="text-6xl font-display font-black text-primary mb-4">1.2k+</p>
                <p className="text-slate-400 font-black uppercase text-[11px] tracking-[0.3em]">Businesses Launched</p>
              </div>
              <div className="p-12 bg-white dark:bg-slate-900 rounded-[48px] border border-slate-100 dark:border-slate-800 shadow-lg group hover:-translate-y-2 transition-transform duration-500">
                <p className="text-6xl font-display font-black text-primary mb-4">₦500M+</p>
                <p className="text-slate-400 font-black uppercase text-[11px] tracking-[0.3em]">Taxes Secured</p>
              </div>
            </div>
          </div>
        </div>

        {/* Core Values - Reimagined with Icons */}
        <div className="bg-slate-900 rounded-[100px] p-16 lg:p-32 text-white overflow-hidden relative shadow-2xl">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/30 rounded-full blur-[160px] -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute -bottom-24 -left-24 w-[400px] h-[400px] bg-accent/10 rounded-full blur-[120px] opacity-30"></div>
          
          <div className="text-center mb-28 relative z-10">
            <h2 className="text-5xl font-display font-bold mb-6">Our Foundational Values</h2>
            <p className="text-xl text-slate-400 font-medium">The principles defining every filing and consultation since day one.</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-20 relative z-10">
            {[
              { 
                icon: 'shield_person', 
                title: 'Unwavering Integrity', 
                desc: 'Zero-tolerance for shortcuts. We ensure your legacy is built on a 100% legal foundation.' 
              },
              { 
                icon: 'auto_mode', 
                title: 'Technological Agility', 
                desc: 'Utilizing AI-driven automation to ensure your filings happen while you sleep.' 
              },
              { 
                icon: 'school', 
                title: 'Subject Expertise', 
                desc: 'Our partners are 20-year veterans of the Nigerian fiscal and regulatory landscape.' 
              },
            ].map((value, i) => (
              <div key={i} className={`text-center animate-reveal stagger-${i+1}`}>
                <div className="w-28 h-28 bg-white/10 rounded-[40px] flex items-center justify-center mx-auto mb-10 hover:scale-110 hover:bg-white/20 transition-all duration-700 group">
                  <span className="material-symbols-rounded text-accent text-5xl group-hover:rotate-12 transition-transform">{value.icon}</span>
                </div>
                <h3 className="text-3xl font-display font-bold mb-6">{value.title}</h3>
                <p className="text-slate-400 leading-relaxed text-xl font-medium">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;